import { styled } from '@mui/material';

import { getShouldForwardPropFn } from '@mopla/utils';

interface IStopSplitterIconProps {
	disabled: boolean;
}

export const StopSplitterIcon = styled('div', {
	shouldForwardProp: getShouldForwardPropFn<IStopSplitterIconProps>('disabled'),
})<IStopSplitterIconProps>(({ theme, disabled }) => ({
	backgroundColor: disabled
		? theme.palette.neutral[60]
		: theme.palette.primary.main,
	justifySelf: 'center',
	alignSelf: 'center',
	position: 'relative',
	minHeight: 22,
	width: 4,
}));
